/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import LoggableCustomEvent from '../Utility/LoggableCustomEvent';
import StateComponent from './StateComponent';
import { StateID } from './StateID';

/** Event class for when a state becomes active. */
export default class StateEvent extends LoggableCustomEvent
{
    /** Name of event for node eventing. */
    public static readonly EventName: string = 'StateEvent';

    /** @hidden */
    private _stateEventName: string;
    /** Accessor to specific [[StateComponent]] instance event name. */
    public get StateEventName(): string {return this._stateEventName; }

    /** @hidden */
    private _state?: StateComponent;
    /** [[StateComponent]] which is being activated. */
    public get State(): StateComponent{ return this._state; }

    /**
     * Constructor for [[StateEvent]]
     * @param state State which is starting.
     * @param bubles Whether event will bubble up.
     */
    constructor(state?: StateComponent, bubbles?: boolean)
    {
        if (!bubbles) { bubbles = false; }

        const stateEventName: string =
            (state)
                ? StateEvent.GetStateEventName(state.StateID)
                : StateEvent.GetStateEventName();

        super(stateEventName, bubbles);

        this._stateEventName = stateEventName;
        this._state = state;
    }

    /**
     * Gets unique event name for given [[StateComponent]]
     * @param state [[StateComponent]] for which to get event name from.
     * @returns Event name.
     */
    public static GetStateEventName(state: StateID = null): string
    {
        return (state !== null)
            ? `${StateID[state]}-${StateEvent.EventName}`
            :  StateEvent.EventName;
    }
}
